import Cookies from 'js-cookie';
import { useState } from 'react';
import CookieConsent from 'react-cookie-consent';
import { useTranslation } from 'react-i18next';

import { analyticsService } from '@/utils/analytics-service';
import { initCampaignTracking } from '@/utils/campaign-service';

export default function CookiesPopup() {
  const [showSettings, setShowSettings] = useState(false);
  const [analytics, setAnalytics] = useState(true);

  const { t } = useTranslation('cookies');

  return (
    <>
      {showSettings && (
        <div className="fixed flex justify-center items-center h-screen w-screen top-0 left-0 bg-[#000000a1] z-[9999]">
          <div className="bg-white p-6 w-fit rounded shadow-lg text-black">
            <h2 className="font-bold mb-4">{t('settings')}</h2>

            <div className="flex items-center gap-2 mb-2">
              <input type="checkbox" checked disabled />
              <label>{t('necessary')}</label>
            </div>

            <div className="flex items-center gap-2 mb-4">
              <input
                type="checkbox"
                checked={analytics}
                className="accent-button"
                onChange={(e) => setAnalytics(e.target.checked)}
              />
              <label>{t('analytics')}</label>
            </div>

            <div className="flex justify-end">
              <button
                onClick={() => {
                  Cookies.set('analytics', analytics ? 'true' : 'false');
                  analyticsService.init();
                  setShowSettings(false);
                }}
                className="bg-button text-white px-4 py-2 rounded"
              >
                {t('save')}
              </button>
            </div>
          </div>
        </div>
      )}

      <CookieConsent
        location="bottom"
        buttonText={t('acceptAll')}
        cookieName="cookie-consent"
        style={{ background: '#050505' }}
        buttonStyle={{
          color: '#fff',
          background: '#a3834d',
          fontSize: '13px',
          borderRadius: '6px',
        }}
        expires={150}
        onAccept={() => {
          Cookies.set('analytics', analytics ? 'true' : 'false');
          if (analytics) analyticsService.init();
          initCampaignTracking();
          setShowSettings(false);
        }}
      >
        {t('message')}
        <button
          onClick={() => setShowSettings(true)}
          className="bg-transparent text-[#a3834d] underline ml-4"
        >
          {t('settingsButton')}
        </button>
      </CookieConsent>
    </>
  );
}
